import React from "react"
import { Container, Grid, Button } from "semantic-ui-react"
import { Link } from "react-router-dom"
import "./Overview.css"

export class OverviewInvited extends React.Component {
  render = () => {
    const { nextUrl } = this.props
    return (
      <Container textAlign="center" className="white">
        <Grid centered className="overview_maindiv">
          <Grid.Row style={{ paddingBottom: "0px" }}>
            <Grid.Column textAlign="center">
              <h2 className="overview__Heading">Welcome to SAVVI!</h2>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ paddingTop: "0px" }}>
            <Grid.Column
              className="overview__Description"
              width={14}
              textAlign="center"
            >
              <p className="overview__DescriptionText">
                A new way to see your money
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row centered columns={3}>
            <Grid.Column>
              <div className="overview_title">Who is SAVVI?</div>
              <p>
                We are MIT-trained data scientists, Ph.D's recognized as world
                leaders in optimization and computer science:
              </p>
              <div>
                <ul className="overview__List">
                  <li>20+years in financial services.</li>
                  <li>Managed billions of $ in assets.</li>
                  <li>
                    Worked with 10,000 financial advisors and their clients.
                  </li>
                </ul>
              </div>
            </Grid.Column>
            <Grid.Column>
              <div className="overview_title">Different how?</div>
              <p>
                SAVVI's independent financial advice is provided under the
                fiduciary standard, which simply means we give advice that is:
              </p>
              <div>
                <ul className="overview__List">
                  <li>In YOUR best interest first.</li>
                  <li>NOT tied to a specific product.</li>
                  <li>
                    PERSONALIZED for the unique circumstances and goals you
                    share with us.
                  </li>
                </ul>
              </div>
            </Grid.Column>
            <Grid.Column>
              <div className="overview_title">Who sees my info?</div>
              <p>
                SAVVI follows strict privacy and security policies. Protecting
                your data is extremely important. Your personal information is:
              </p>
              <div>
                <ul className="overview__List">
                  <li>NEVER SOLD, you are our client.</li>
                  <li>NOT SHARED without your permission.</li>
                  <li>
                    SAFEGUARDED by layers of physical, process, and technology
                    protections.
                  </li>
                </ul>
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign="center">
              <div className="overview_Button_Div">
                The agreements you’re about to see acknowledge our promises to
                you.
              </div>
              <div className="overview_details">
                Ready? Okay… Review. Accept. Go!
              </div>

              <div style={{ textAlign: "center" }}>
                <Link to={nextUrl} className="navlink">
                  <Button
                    primary
                    size="big"
                    className="overview_Button"
                    data-testid="continue"
                  >
                    Continue
                  </Button>
                </Link>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    )
  }
}
